<template>
<div class="info">
	<div class="title">保障计划及人员
		<a class="title-a" v-if="from=='policy'&&(info.statusCode==2||info.statusCode==3)" @click="toEdit">参加人员编辑</a>
		<!-- <a 
			:href="`/pc/cxw/exportInsurancePersonnels?id=${info.id}`" 
			target="_blank" 
			v-if="from=='policy'"
			class="title-a"
		>下载参加人员信息</a> -->
	</div>
	
	<Form :label-width="120" ref="form" class="mt15">
		<template  v-if="from!='policy'">
			<FormItem label="保障期限：" class="w600">{{info.insuredPeriodName}}</FormItem>
			<FormItem label="保障起期：" class="w600">{{info.effectiveDateStart}}</FormItem>
			<FormItem label="保障止期：" class="w600">{{info.effectiveDateEnd}}</FormItem>
		</template>
		<FormItem label="附加险：" class="w600" v-if="info.subjoinAllDay||info.subjoinOwnMedicine||info.subjoinProportionAdj">
			<p v-if="info.subjoinAllDay">附加24小时伤残+医疗 基础方案价格*115%</p>
			<p v-if="info.subjoinOwnMedicine">附加自费药补偿 基础方案价格*120%</p>
			<p v-if="info.subjoinProportionAdj">附加伤残赔偿比例  基础方案价格*115%</p>
		</FormItem>
	</Form>
	<div class="recognize-table mt10 pb20">
		<e-table :list="list">
			<el-table-column prop="no" label="序号" width="70" align="center" fixed>
				<template slot-scope="scope">
					{{scope.$index+1}}
				</template>
			</el-table-column>
			<el-table-column prop="isAerial" label="是否高空" width="100">
				<template slot-scope="{ row }">
					{{row.isAerial?'高空':'非高空'}}
				</template>
			</el-table-column>
			<el-table-column prop="jobTypeName" label="工种" show-overflow-tooltip width="150"></el-table-column>
			<el-table-column prop="insuranceSchemeName" label="保障方案" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="insurantName" label="姓名" width="120"></el-table-column>
			<el-table-column prop="insurantCertificateNumber" label="身份证号" width="190">
				<template slot-scope="{ row }">
					{{from=='order'?hideIdCard(row.insurantCertificateNumber):row.insurantCertificateNumber}}
				</template>
			</el-table-column>
			<el-table-column prop="insurantGender" label="性别" width="70">
				<template slot-scope="{ row }" slot="insurantGender">
					{{row.insurantGender==1?'男':'女'}}
				</template>
			</el-table-column>
			<el-table-column prop="insurantAge" label="年龄" width="70"></el-table-column>

			<el-table-column prop="effectiveDateStart" label="保障起期" width="180"></el-table-column>
			<el-table-column prop="effectiveDateEnd" label="保障止期" width="180"></el-table-column>
			<el-table-column v-if="from=='confirm'" prop="insurantAmount" label="保费(元)" width="120"></el-table-column>
			<el-table-column v-if="from!='confirm'" prop="insuranceStatusName" label="保障状态" width="100"></el-table-column>
			<el-table-column v-if="from!='confirm'" prop="remarks" show-overflow-tooltip label="备注" width="120"></el-table-column>
		</e-table>
	</div>
	<Form :label-width="120" ref="form" v-if="from!='confirm'">
		<FormItem 
			label="投保单：" 
			class="w600">
			<div style="display:flex;flex-wrap:wrap;">
				<ImageShow 
					v-for="(img,i) in info.insurancePolicyUrl"
					:url="img"
					:del="!info.isCorrect"
					@del-img="delImg(i)"
					:key="i" />
				<UploadFileImg v-if="$route.query.orderType==1&&!info.correctUrl"
					@on-success="val=>uploadSuccess(val)" 
					:accept="['image']"
					style="width:100px">
					<div class="upload-img-main">
						<Icon type="ios-camera" size="20"></Icon>
						<p>点击上传</p>
					</div>
				</UploadFileImg>
			</div>
		</FormItem>
        <FormItem 
            label="批改单（盖章）：" :label-width="140" v-if="info.correctUrl||(info.correctUrls&&info.correctUrls.length>0)">
            <div style="display:flex;flex-wrap:wrap;" v-if="from=='policy'">
                <div v-for="(item,i) in info.correctUrls" :key="i" class="correctUrlItem">
                    <img :src="item.correctUrl" height="140"/>
                    <p>
						<a :href="item.correctUrl" target="_blank">查看大图</a>
						{{item.createTime}}
					</p>
                </div>
            </div>
            <div style="display:flex;margin-top: 14px;" v-if="from=='order'">
                <!-- <ImageShow :url="info.correctUrl"/> -->
                <div style="display:flex;flex-wrap:wrap;">
                    <div v-for="(item,i) in info.correctUrls" :key="i" class="correctUrlItem">
                        <img :src="item.correctUrl" height="140"/>
                        <p>
                            <a :href="item.correctUrl" target="_blank">查看大图</a>
                            <a @click="del(i)" v-if="info.correctUrls.length!=1" style="color:red">删除</a>
                            <!-- {{item.createTime}} -->
                        </p>
                    </div>
                </div>
				<UploadFileImg v-if="$route.query.orderType==1&&info.isCorrect"
					@on-success="val=>uploadSuccess(val,'correctUrls')" 
					:accept="['image']"
					style="width:100px">
					<div class="upload-img-main">
						<Icon type="ios-camera" size="20"></Icon>
						<p>上传</p>
					</div>
				</UploadFileImg>
            </div>
        </FormItem>
	</Form>
</div>
</template>
<script>
import ImageShow from '../common/Image'
import UploadFileImg from '@/components/common/UploadFileImg'
import eTable from '@/components/common/eTable'
export default {
	components:{ImageShow,UploadFileImg,eTable},
	props:{
		info:Object,
		from:{
			type:String,
			default:'confirm'// confirm/order/policy
		},
	},
	data () {
		return {
			list:[],
			imgList:[]
		}
	},
	computed:{
	   days(){
			if(this.info.effectiveDateStart&&this.info.effectiveDateEnd){
				return this.getDays(this.formatDate(this.info.effectiveDateStart),this.formatDate(this.info.effectiveDateEnd));
			}else {
				return ""
			}
		},
	},
	watch:{
		info (v) {
			if(v.list&&v.list.length>0){
				this.list=v.list
			}
		}
	},
	created(){
		
		
		if(this.info.list&&this.info.list.length>0){
			this.list=this.info.list
		}
		console.log(this.info)
	},
	methods: {
		// 上传回调方法
		uploadSuccess(val,key){
            console.log('---------------------------------')
            console.log(val)
            console.log(key)
			if (key) this.info[key].push({correctUrl: val.url})
			else this.info.insurancePolicyUrl.push(val.url)
		},
		delImg (index) {
			this.info.insurancePolicyUrl.splice(index,1)
		},
        del (index) {
			this.info.correctUrls.splice(index,1)
		},
		hideIdCard (str,frontLen=4,endLen=3) { 
			var len = str.length-frontLen-endLen;
			var star = '';
			for (var i=0;i<len;i++) {
				star+='*';
			}
			return str.substring(0,frontLen)+star+str.substring(str.length-endLen);
		},
		toEdit () {
			this.checkOrderRefuseStatus({
				policyId:this.info.id,
				bizCode:'KAS_GZ_GYS'
			}).then(()=>{
				this.$axios.post('/employerLiability/checkUnPaidOrder.json',{
					id:this.info.id
				}).then(res=>{
					if(res){
						this.$router.push(`/company-group-employergs/edit/${this.info.id}`)
					}
				});
			})
		}
	},
}
</script>
<style scoped lang="less">
.info{
	margin-top:10px;
}
	.title-a{
		font-size: 14px;
		margin-left: 15px;
	}
	.pb20{
		padding-bottom: 20px;
	}
    .correctUrlItem{
        margin-right: 20px;
        text-align: center;
		a{
			font-size: 12px;
			// display: block;
            margin-right: 5px;
		}
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerGS/RecognizeInfo.vue